module.exports = __webpack_public_path__ + "img/po.4799ab65.png";